import React, { Fragment, useState } from 'react';
import { Modal, Button, Space, Card } from "antd";
import { PlusOutlined, EditOutlined, CloseOutlined } from '@ant-design/icons';
import { IconPicker, Icon } from "./IconSelect";


const InputIconSelect = ({ value, onChange }) => {
    const [open, setOpen] = useState(false);

    const handleOpenModal = () => {
        setOpen(true);
    };

    const handleCloseModal = () => {
        setOpen(false);
    };

    const handleChange = (newValue) => {
        if (onChange) {
            onChange(newValue);
        }
        setOpen(false);
    };

    const handleClear = (e) => {
        e.stopPropagation();
        if (onChange) {
            onChange(null);
        }
    };

    return (
        <Fragment>
            <div 
                onClick={handleOpenModal}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: value ? 'space-between' : 'center',
                    height: '40px',
                    padding: '0 12px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    transition: 'all 0.3s',
                    backgroundColor: '#fff',
                    ':hover': {
                        borderColor: '#40a9ff',
                        boxShadow: '0 0 0 2px rgba(24, 144, 255, 0.2)'
                    }
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#40a9ff';
                    e.currentTarget.style.boxShadow = '0 0 0 2px rgba(24, 144, 255, 0.2)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#d9d9d9';
                    e.currentTarget.style.boxShadow = 'none';
                }}
            >
                {value ? (
                    <>
                        <Space>
                            <Icon {...value} />
                            <span style={{ color: '#666' }}>{value.iconName}</span>
                        </Space>
                        <Button 
                            type="text" 
                            size="small" 
                            icon={<CloseOutlined />} 
                            onClick={handleClear}
                            style={{ color: '#999' }}
                        />
                    </>
                ) : (
                    <Space>
                        <PlusOutlined style={{ color: '#999' }} />
                        <span style={{ color: '#999' }}>请选择图标</span>
                    </Space>
                )}
            </div>

            <Modal 
                title="选择图标"
                width={900}
                open={open}
                footer={null}
                onCancel={handleCloseModal}
                destroyOnClose
                styles={{ body: { padding: '16px' } }}
            >
                <IconPicker 
                    value={value} 
                    onChange={handleChange} 
                />
            </Modal>
        </Fragment>
    );
}

export default InputIconSelect;